import { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../../utils/config/config";

// The endpoint returns every subscriber in one call — the list is small and
// filtering/paging client-side keeps search instant.
export const useSubscribers = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await axiosInstance.get("blog/admin/subscribers");
      setItems(Array.isArray(data) ? data : []);
    } catch (err) {
      setItems([]);
      setError(err.response?.data?.message || "Failed to load subscribers");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return { items, loading, error, reload: load };
};
